import React from 'react';

export const Add = ({ color = '#242424' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none">
    <path d="M8.00012 13.6569V2.34315" stroke={color} />
    <path d="M2.34315 7.99999H13.6569" stroke={color} />
  </svg>
);
